"use client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { McThemeProvider } from "@/lib/theme/ThemeProvider";
import { BrandFavicon } from "@/lib/theme/branding";
import { ModeDefault } from "@/lib/theme/mode";
import { ReactNode, useState } from "react";

export default function Providers({ children }: { children: ReactNode }) {
  const [client] = useState(() => new QueryClient());
  return (
    <ThemeProvider attribute="class" defaultTheme="light">
      <QueryClientProvider client={client}>
        <McThemeProvider><BrandFavicon /><ModeDefault />{children}</McThemeProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}
